var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4859 9.41692C17.4859 14.5621 13.5722 18.7342 8.742 18.7342C7.59551 18.7358 6.45995 18.4961 5.40014 18.0288C4.34034 17.5614 3.37706 16.8756 2.56529 16.0104C1.75352 15.1452 1.10916 14.1176 0.669007 12.9863C0.228854 11.855 0.0015256 10.6421 0 9.41692C0 4.26963 3.91375 0.0996206 8.742 0.0996206C9.88865 0.097716 11.0244 0.337219 12.0845 0.804452C13.1445 1.27168 14.108 1.95749 14.92 2.82271C15.7319 3.68793 16.3765 4.71561 16.8167 5.84705C17.257 6.9785 17.4844 8.19155 17.4859 9.41692ZM27.0766 9.41692C27.0766 14.2619 25.1197 18.1876 22.7056 18.1876C20.2914 18.1876 18.3346 14.2598 18.3346 9.41692C18.3346 4.57192 20.2914 0.646235 22.7056 0.646235C25.1197 0.646235 27.0766 4.57399 27.0766 9.41692ZM31 9.41692C31 13.7567 30.3122 17.2745 29.4616 17.2745C28.613 17.2745 27.9252 13.7546 27.9252 9.41692C27.9252 5.07713 28.613 1.55933 29.4636 1.55933C30.3122 1.55933 31 5.07713 31 9.41692Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.b6eea4665ea910965fe1e90df1c19e8c.svg";
export { ForwardRef as ReactComponent };